import withBugsnag from '@/react/shared/BugsnagProvider';
import QuotaMinderServers from './IndexPage';

export default withBugsnag(QuotaMinderServers);
